<template>
  <div class="w-[100vw] h-[100vh] flex flex-col">
    <div class="h-8" style="app-region: drag;"></div>
    <div class="flex-1 p-8 flex flex-col-reverse items-center justify-center">
      <div>
        <AppAlert
          v-if="loginFailed"
          type="error"
        >
          Loginpoging mislukt. Controleer uw gebruikersnaam en wachtwoord.
        </AppAlert>
      </div>
      <div
        class="flex flex-row-reverse flex-wrap rounded-xl shadow-xl max-w-sm sm:max-w-xl w-full bg-white overflow-hidden justify-between"
      >
        <FormKit
          ref="form"
          v-model="credentials"
          form-class="displayContents"
          type="form"
          :disabled="isSubmitting"
          :actions="false"
          @submit="attemptLogin"
        >
          <div class="p-8 flex flex-col grow">
            <div class="mb-8 text-3xl font-bold inline-flex gap-3 items-center">
              Inloggen
            </div>
            <FormKit
              type="text"
              name="username"
              label="Gebruikersnaam"
            />
            <FormKit
              id="password"
              type="password"
              name="password"
              label="Wachtwoord"
              @keyup.enter="attemptLogin"
            />

            <FormKit
              v-show="mfaRequired"
              ref="mfaCodeInput"
              type="text"
              name="mfaCode"
              label="Authenticator code"
              input-class="mfa-code-input"
              @keyup.enter="attemptLogin"
            />
            <AppButton
              icon="arrow-right"
              class="ml-auto"
              :disabled="isSubmitting"
              @click="attemptLogin"
            >
              Inloggen
            </AppButton>
          </div>
        </FormKit>
        <div
          class="p-8 min-w-[240px] grow flex flex-col relative bg-neutral-900 text-white"
        >
          <Transition
            name="slide-right-to-left"
            mode="out-in"
          >
            <AppIcon
              v-if="!loginWasSuccess"
              class="m-auto h-36 w-36"
              :class="lockIconClass"
              icon="fa-regular fa-lock"
            />
            <AppIcon
              v-else-if="loginWasSuccess"
              class="m-auto h-36 w-36"
              icon="fa-regular fa-lock-open"
            />
          </Transition>
          <span class="absolute bottom-2 right-3 text-sm">
            CFood &dash; v{{ buildVersion }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { login } from "@q-food/q-food";
import { useAppStore } from "~/stores/App";
import { useUserStore } from "~stores/User";

const buildVersion = __APP_BUILD_VERSION__;

const mfaCodeInput = ref();
const { setToken } = useUserStore();
const { mfaRequired } = storeToRefs(useUserStore());

const loginWasSuccess = ref(false);
const isSubmitting = ref(false);
const lockIconClass = ref("");

const credentials = ref({
	username: "",
	password: "",
	mfaCode: null as string | null,
});

const loginFailed = ref(false);

async function attemptLogin() {
	isSubmitting.value = true;
	loginFailed.value = false;

	try {
		const loginResult = await login(credentials.value);
		loginWasSuccess.value = true;
		setTimeout(async () => {
			await setToken(loginResult.sessionId, loginResult.mfaRequired);
			await useAppStore().refreshApp();
			if (loginResult.mfaRequired) {
				document.querySelector<HTMLInputElement>("input.mfa-code-input")!.focus();
			}
		}, 750);
	} catch (error) {
		loginFailed.value = true;
		lockIconClass.value = "shake";
		setTimeout(() => {
			lockIconClass.value = "";
		}, 1000);
		throw error;
	} finally {
		isSubmitting.value = false;
	}
}
</script>

<style scoped>
.displayContents {
  @apply contents;
}

.shake {
  /* also need animation and -moz-animation */
  -webkit-animation: shake 0.5s linear;
}

@-webkit-keyframes shake {
  8%,
  41% {
    -webkit-transform: translateX(-10px);
  }
  25%,
  58% {
    -webkit-transform: translateX(10px);
  }
  75% {
    -webkit-transform: translateX(-5px);
  }
  92% {
    -webkit-transform: translateX(5px);
  }
  0%,
  100% {
    -webkit-transform: translateX(0);
  }
}
</style>
